import { render, staticRenderFns } from "./exhibition_release.vue?vue&type=template&id=258fc0ee&scoped=true&"
import script from "./exhibition_release.vue?vue&type=script&lang=js&"
export * from "./exhibition_release.vue?vue&type=script&lang=js&"
import style0 from "./exhibition_release.vue?vue&type=style&index=0&id=258fc0ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258fc0ee",
  null
  
)

export default component.exports